



























































































































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import SearchBar from '@/components/SearchBar.vue';
import { Action, Getter } from 'vuex-class';
import AccountService from '@/services/account.service';
import moment from 'moment';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import { CommercialAccount } from '../../types';
import store from '@/store/store';

@Component({
  components: {
    ConfirmButton,
    CancelButton,
    Dialog,
    SearchBar,
  },
})
export default class AdminAccounts extends Vue {

  private account: any = null;
  private showAddEditDialog: boolean = false;
  private isSaving: boolean = false;
  private licensedAtMenu: boolean = false;
  private licenseExpiresMenu: boolean = false;
  @Getter private hasPermission: any;
  @Getter private organisations: any;

  private headers = [
    { text: 'Id', value: 'id'},
    { text: 'Name', value: 'name' },
    { text: 'Contact', value: 'contact_name' },
    { text: 'Email', value: 'contact_email' },
    { text: 'Licensed', value: 'display_licensed_at' },
    { text: 'License Expires', value: 'display_license_expires' },
    { text: 'Legal Entity', value: 'legal_entity_name' },
    { text: 'Sage Reference', value: 'sage_account_id' },
  ];
  private accounts: any = [];
  private adding: boolean = false;
  private createHomeOrg: boolean = false;

  public async mounted() {
    if (!this.hasPermission('administration:view')) {
      this.$router.push('/');
    }

    await this.loadAccounts();
  }

  private async loadAccounts() {
    const accounts = await AccountService.getCommercialAccounts();

    const displayAccounts = accounts.map((a: CommercialAccount) => {
      const acc: any = Object.assign({}, a);
      acc.display_licensed_at = acc.licensed_at;
      acc.display_license_expires = acc.license_expires;
      acc.licensed_at = acc.licensed_at ? moment(acc.licensed_at).format('YYYY-MM-DD') : null;
      acc.license_expires = acc.license_expires ? moment(acc.license_expires).format('YYYY-MM-DD') : null;
      return acc;
    });

    this.accounts = displayAccounts;
  }

  private getExpiryDate(acc: CommercialAccount) {
    return acc.license_expires ? moment(acc.license_expires).format('DD MMM YYYY') : undefined;
  }

  private getLicensedDate(acc: CommercialAccount) {
    return acc.licensed_at ? moment(acc.licensed_at).format('DD MMM YYYY') : undefined;
  }

  private get licensedAt(): string {
    return this.account.licensed_at ? moment(this.account.licensed_at).format('DD MMM YYYY') : '';
  }

  private set licensedAt(val) {
    if (!val || !val.length) {
      this.account.licensed_at = null;
    }
  }

  private get licenseExpires(): string {
    return this.account.license_expires ? moment(this.account.license_expires).format('DD MMM YYYY') : '';
  }

  private set licenseExpires(val) {
    if (!val || !val.length) {
      this.account.license_expires = null;
    }
  }

  private async addAccount() {
    this.account = {
      name: null,
      contact_name: null,
      contact_email: null,
      home_organisation_id: null,
      licensed_at: null,
      license_expires: null,
    };
    this.createHomeOrg = false;
    this.adding = true;

    this.showAddEditDialog = true;
  }

  private async showAccount(account: any) {
    this.account = { ...account };
    this.adding = false;

    this.showAddEditDialog = true;
  }

  private async save() {
    try {
      this.isSaving = true;
      if (this.account.id) {
        await AccountService.updateCommercialAccount(this.account);
      } else {
        await AccountService.createCommercialAccount({...this.account, create_home_org: this.createHomeOrg});
        await store.dispatch('addAccountsAsync');
        if (this.createHomeOrg) {
          await store.dispatch('addOrganisationsAsync');
        }
      }
      await this.loadAccounts();
      this.showAddEditDialog = false;
    } finally {
      this.isSaving = false;
    }
  }

  private close() {
    this.showAddEditDialog = false;
  }
}
